import React from 'react';
import { List, Ellipsis, SpinLoading, ProgressCircle, ErrorBlock } from 'antd-mobile';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';

const Defects = styled(List)`
	width: 100%;
	padding: 12px 0px;
	.adm-list-item-content-extra {
		display: flex;
	}
`;

const Progress = styled(ProgressCircle)`
	font-size: 12px;
`;

const SpinWrapper = styled.div`
	display: flex;
	width: 100%;
	height: 100%;
	align-items: center;
	justify-content: center;
`;

function DefectsList(props) {
	const {
		defects,
		loading,
		stats,
		workOrderId
	} = props;
	const history = useHistory();

	function getList() {
		if (!defects.length) {
			return <ErrorBlock
				style={{ paddingTop: 12 }}
				title="No additional works found"
				description=""
				status='empty'
			/>;
		}

		return <Defects>
			{defects.map((defect) => {
				const itemStats = stats.find(s => s.id === defect.id);
				let progress = <Progress percent={0}>N/A</Progress>;

				if (itemStats) {
					const precent = (itemStats.done_items / itemStats.total_items) * 100;
					progress = <Progress
						percent={precent}
						style={{
							'--fill-color': itemStats.all_done ? 'var(--adm-color-success)' : 'var(--adm-color-primary)'
						}}
					>
						{itemStats.all_done ? 'DONE' : `${itemStats.done_items}/${itemStats.total_items}`}
					</Progress>;
				}
				return <List.Item
					extra={progress}
					key={defect.id}
					description={<Ellipsis direction='end' rows={3} content={defect.restification_method || '-'} />}
					onClick={() => history.push(`/work-order/${workOrderId}/defect/${defect.id}`)}
					clickable
				>
					<Ellipsis direction='end' rows={3} content={defect.description || '-'} />
				</List.Item>;
			})}
		</Defects>;
	}

	return (
		loading ? <SpinWrapper><SpinLoading style={{ '--size': '48px' }} /></SpinWrapper> : getList()
	);
}

export default DefectsList;
